/*
 * @Author: Zhao Wang
 * @Date: 2026-08-25
 * @Description: 航空救援力量动态（新版服务站 galss 外部接口，无 Token，服务端已全局放开 CORS）
 */
import config from "@/config";
import http from "@/utils/request";

export default {
    mixedFlightRecord: {
        // 合并列表查询（有人机+无人机）
        // 入参：pageNumber、pageSize、positionId(默认4)、companyName(公司名称)、
        //       aircraftModel(飞机型号，含中大型无人机)、takeoffAirport(起飞机场)；
        //       时间未传默认当天；出参：data 为 PageInfo{list,total,pageNum,pageSize,pages}
        queryList: {
            url: `${config.GALSS_URL}/api/v1/lss/flightRecord/external/queryMixedFlightRecordList`,
            name: "查询航空救援力量动态列表",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
        // 导出全部符合筛选条件的数据（列布局与页面表格一致）
        // 入参：筛选条件与列表查询一致 + exportType(excel=Excel默认/word=Word)；
        //       需以 blob 方式接收（axiosConfig 传 { responseType: 'blob' }）
        exportList: {
            url: `${config.GALSS_URL}/api/v1/lss/flightRecord/external/exportMixedFlightRecordList`,
            name: "导出航空救援力量动态",
            post: async function (params, axiosConfig) {
                return await http.post(this.url, params, axiosConfig);
            },
        },
        // 当日航空器机型统计：按本省(本系统申报)/邻省(中南推送)分组，同一来源内同一机号只统计一次，
        //       两边都出现则各计一次；不跟随公司/机型/机号/机场筛选条件
        // 入参：positionId(默认4)、actualExecutionDateBegin/End(未传默认当天)；
        // 出参：data 为 { executionDateBegin, executionDateEnd,
        //         local:    { sourceCode:'LOCAL',    sourceName:'本省', total, items:[{ aircraftTypeCode, aircraftTypeName, count }] },
        //         neighbor: { sourceCode:'NEIGHBOR', sourceName:'邻省', total, items:[...同上] } }
        //       items 包含全部启用的航空器分类（AIRCRAFT_2 直升机/AIRCRAFT_3 固定翼/AIRCRAFT_4 旋翼机/
        //       AIRCRAFT_5 三角翼/AIRCRAFT_6 飞行伞/AIRCRAFT_7 热气球/AIRCRAFT_8 飞艇/AIRCRAFT_9 无人机）
        //       及 UNCLASSIFIED 未分类，未出现的类型 count 为 0，前端按需选取展示
        queryAircraftStatistics: {
            url: `${config.GALSS_URL}/api/v1/lss/flightRecord/external/queryMixedAircraftStatistics`,
            name: "查询航空救援力量动态航空器机型统计",
            post: async function (params) {
                return await http.post(this.url, params);
            },
        },
    },
};
